import React from 'react'
import { Link } from 'react-router-dom'
import { AudioSystem } from './AudioSystem'

export const Hero: React.FC = () => {
  return (
    <section className="bg-gradient-to-br from-slate-50 to-white pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="fade-in-up lg:order-2">
            <div className="bg-slate-100 border border-slate-400 text-slate-800 px-4 py-2 rounded-lg text-sm font-bold mb-6 inline-block">
              ⚠️ ATTORNEY SCAM EXPOSED BELOW
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-6">
              <span className="text-blue-700">Timeshare Attorney</span><br />
              <span className="text-slate-700">SCAM EXPOSED</span>
            </h1>
            
            <p className="text-xl text-gray-700 mb-8 leading-relaxed">
              Why pay attorneys <strong className="text-slate-800">$5,000-$15,000</strong> when you can 
              legally exit your timeshare yourself for just <strong className="text-blue-700">$997</strong>? 
              Our DIY guide uses the exact same strategies attorneys use.
            </p>
            
            <div className="bg-blue-50 border-l-4 border-blue-600 p-4 mb-8">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-slate-800">
                    <strong>PROFESSIONAL FACT:</strong> Most attorneys use the same basic legal templates we provide in our guide. 
                    You're paying thousands for strategies you can execute yourself.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Link 
                to="/register"
                className="btn-primary text-lg px-8 py-4 text-center no-underline"
              >
                Get Professional DIY Guide - Save $10,000+ Now
              </Link>
              <Link 
                to="/calculator" 
                className="btn-secondary text-lg px-8 py-4 text-center"
              >
                Calculate Your Savings
              </Link>
            </div>
            
            <div className="flex items-center text-sm text-slate-600">
              <svg className="h-5 w-5 text-blue-600 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>60-Day Money Back Guarantee • 4,847+ Success Stories • Instant Access</span>
            </div>
          </div>
          
          {/* Right Column - Audio System */}
          <div className="relative lg:order-1">
            <div className="bg-white rounded-xl shadow-2xl p-4 border">
              <div className="mb-4">
                <h3 className="text-xl font-bold text-gray-900 text-center">
                  Audio: AI Explains the Attorney Scam
                </h3>
                <p className="text-sm text-gray-600 text-center mt-2">
                  Listen to our comprehensive audio explanation of how attorneys overcharge for timeshare exits
                </p>
              </div>
              
              {/* Audio System */}
              <AudioSystem onAudioChange={(isPlaying, track) => {
                console.log('Audio status:', { isPlaying, track })
              }} />
              
              {/* Audio Benefits */}
              <div className="mt-4 grid grid-cols-2 gap-3 text-xs">
                <div className="bg-blue-50 border border-blue-300 rounded-lg p-3 text-center">
                  <div className="font-semibold text-blue-800">DIY Guide</div>
                  <div className="text-blue-600">3-6 months</div>
                  <div className="text-blue-600 font-bold">$997</div>
                </div>
                <div className="bg-slate-100 border border-slate-300 rounded-lg p-3 text-center">
                  <div className="font-semibold text-slate-800">Attorneys</div>
                  <div className="text-slate-600">12+ months</div>
                  <div className="text-slate-800 font-bold">$5K-$15K</div>
                </div>
              </div>
              
              {/* Audio CTA */}
              <div className="mt-4 text-center">
                <Link 
                  to="/register"
                  className="w-full bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 px-4 rounded-lg transition-colors no-underline block"
                >
                  Audio Playing Above - Get the Complete DIY Guide Now
                </Link>
                <p className="text-xs text-gray-500 mt-2">
                  Join 4,847+ people who saved $10,000+ vs attorney fees
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}